import { render, staticRenderFns } from "./_feedInstagram.vue?vue&type=template&id=4892a30c&"
import script from "./_feedInstagram.vue?vue&type=script&lang=js&"
export * from "./_feedInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports